"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SetConfigurator = /** @class */ (function () {
    function SetConfigurator() {
        this.wrapperClass = '.set-configuration__content';
        this.init();
    }
    SetConfigurator.prototype.init = function () {
        var _this = this;
        // Select first visible item
        this.selectFirstItem(this.wrapperClass + ':visible');
        // Bind item click select
        $(this.wrapperClass + ' a').each(function (i, item) { return _this.bindItemClickEvent(item); });
        // Detect tab change event
        $(document).on('tedeeTabChanged', function (e, eventInfo) { return _this.selectFirstItem(eventInfo); });
        this.onByNowButtonClickEvent();
    };
    SetConfigurator.prototype.onByNowButtonClickEvent = function () {
        $('.set-configuration--button').on('click', function (e) {
            var $activeButton = $(e.target).closest('.container').find('.set-configuration__content .active');
            document.location.href = $activeButton.data('variation');
        });
    };
    SetConfigurator.prototype.selectFirstItem = function (selectorName) {
        $(selectorName).find('.tedee-thumbnail--link').first().addClass('active');
    };
    SetConfigurator.prototype.bindItemClickEvent = function (item) {
        var _this = this;
        item.addEventListener('click', function (e) {
            $(_this.wrapperClass + ' a').removeClass('active');
            $(item).addClass('active');
        });
    };
    return SetConfigurator;
}());
exports.default = SetConfigurator;
